import { Injectable } from "@angular/core";
import { ApplicationInsights, IConfig } from '@microsoft/applicationinsights-web';
import { environment } from "environments/environment";

@Injectable()
export class AppInsightSvc {

  public targetDate: Date;
  public numberOfRecordsInFilter: number; 

    private appInsights = new ApplicationInsights(
        {  
            config: { 
                instrumentationKey: environment.applicationInsights_instrumentationKey
            }
        }
    );

    constructor() {  
        this.appInsights.loadAppInsights();
        //this.appInsights.setAuthenticatedUserContext("3323", "USER1", true);
    }

    public logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {
        console.log("logPageView");
        this.appInsights.trackPageView();
    }

    public trackException(error: Error) { 
        console.warn("AppInsightSvc.trackError", error);
        this.appInsights.trackException({ exception: error })
    }


}
